import { SxProps } from '@mui/material';
import { red } from 'app/components/ThemeProvider/colors';

export const wrapper: SxProps = {
  marginTop: '3px',
  color: red,
  fontWeight: 500,
  fontSize: '12px',
};
